import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { ContactLine } from "./ContactLine";

const LegalModal = ({ onClose }) => {
  const { t } = useLang();
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="modal-backdrop" onClick={onClose} data-testid="legal-modal">
      <div className="panel modal" role="dialog" aria-modal="true" aria-labelledby="legal-title" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <p className="eyebrow">IndusHub Afrique</p>
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClose} aria-label="Close" autoFocus data-testid="legal-modal-close-btn"><X /></button>
        </div>
        <h3 id="legal-title">{t.footer.legalTitle}</h3>
        <p>{t.footer.legalBody}</p>
      </div>
    </div>
  );
};

export const Footer = () => {
  const { t } = useLang();
  const [legal, setLegal] = useState(false);
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="wrap"><ContactLine variant="footer" testid="footer-contact-info" /></div>
      <div className="wrap foot-row">
        <div>{t.footer.copy}</div>
        <div className="foot-links">
          {t.nav.links.filter(([id]) => ["verticaux", "services", "reseau"].includes(id)).map(([id, label]) => (
            <a key={id} href={`#${id}`} data-testid={`footer-link-${id}`}>{label}</a>
          ))}
          <button type="button" onClick={() => setLegal(true)} data-testid="footer-legal-btn">{t.footer.legal}</button>
          <Link to="/admin" data-testid="footer-admin-link">{t.footer.admin}</Link>
        </div>
      </div>
      {legal && <LegalModal onClose={() => setLegal(false)} />}
    </footer>
  );
};
